import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MarketsService } from '../../core/markets/markets.service';
import { ActionListDialogComponent, ActionListDialogData } from './action-list-dialog.component';
import { EntityType } from '@vendasta/automata';

@Component({
  template: `
    <automata-start-manual-automation-form
      [title]="'AUTOMATIONS.MANUAL_AUTOMATIONS.LIST_DIALOG_TITLE' | translate: { name: actionList.name }"
      [partnerId]="partnerId$ | async"
      [marketIds]="marketIds$ | async"
      [hasAllMarketAccess]="hasAllMarketAccess$ | async"
      [warnings]="['AUTOMATIONS.MANUAL_AUTOMATIONS.LIST_WARNINGS']"
      [actionListName]="actionList.name"
      [entityType]="accountGroupEntityType"
      (cancel)="cancel()"
      (success)="cancel()"
    ></automata-start-manual-automation-form>
  `,
})
export class StartAutomationDialogComponent extends ActionListDialogComponent implements OnInit {
  accountGroupEntityType = EntityType.ENTITY_TYPE_ACCOUNT_GROUP;
  maximumNumberOfAccounts = 10000;
  marketIds$: Observable<string[]> = this.markets$.pipe(
    take(1),
    map((markets) => markets.map((m) => m.marketId)),
  );
  hasAllMarketAccess$: Observable<boolean>;

  constructor(
    public dialogRef: MatDialogRef<StartAutomationDialogComponent>,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) private readonly data: ActionListDialogData,
    private snackbarService: SnackbarService,
    @Inject('partnerId$') public readonly partnerId$: Observable<string>,
    @Inject('markets$') private readonly markets$: Observable<any[]>,
    private readonly alertService: SnackbarService,
    private readonly marketsService: MarketsService,
  ) {
    super(dialogRef, router);
  }

  ngOnInit(): void {
    this.hasAllMarketAccess$ = this.marketsService.adminCanAccessAllPartnerMarkets$;
    if (this.itemCount > this.maximumNumberOfAccounts) {
      this.alertService.errorSnack('AUTOMATIONS.ERRORS.LIST_TOO_LARGE');
      this.dialogRef.close();
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
